//Note that this should be kept in sync with the model validation on pagebase dto
export const DATA_TABLE_DEFAULTS = {
  PageSizeOptions: [20, 30, 50, 100, 200, 500]
}
